module.exports = __webpack_public_path__ + "static/media/debt_icon.36dc00f9.svg";